import { Component, OnInit, AfterViewInit, OnDestroy, ViewChildren, QueryList, ElementRef, ViewChild } from '@angular/core';
import { DownloadProgressService } from 'src/app/_service/download-progress.service';
import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';
import { WalletinfoService } from 'src/app/_service/walletinfo.service';
import { URLS } from 'src/app/constants/URLS';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { WhiteLabelService } from 'src/app/_service/white-label.service';
import { IosBridgeService } from 'src/app/_service/ios-bridge.service';
import { DeviceService } from 'src/app/_service/tv-detect.service';
import { TVNavigationService, Region } from 'src/app/_service/tv-navigation.service';
import { Subscription } from 'rxjs';
import { AdResolverService } from 'src/app/_service/ad-resolver.service';
import { AD_CONFIG } from 'src/app/constants/ad-config';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { Html5Qrcode } from 'html5-qrcode';

declare let window;

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit, AfterViewInit, OnDestroy {

  screenname:string = '';
  mail:string = '';
  contact:string = '';
  watchlistList:any[] = [];
  queue:any[] = [];
  historyList:any[] = [];
  downloadList:any[] = [];
  userId:string = '';
  profileImage:string = '';
  wallet:any;
  mediaUrl:any = URLS.profileImageBaseUrl;
  isLoading:boolean = false;
  imgUrl:string = URLS.imgUrl;

  // Per-section loading states for skeleton UI
  isWatchlistLoading = true;
  isHistoryLoading = true;

  // QR scanner properties
  isMobile = false;
  isScannerOpen = false;
  isScannerActive = false;
  isScanProcessing = false;
  scanError = '';
  private html5QrCode!: Html5Qrcode;

  // TV navigation properties
  @ViewChildren('accountItem') accountItems!: QueryList<ElementRef>;
  @ViewChild('actionsContainer') actionsContainer!: ElementRef;
  isTV = false;
  focusedItemIndex = -1;
  private focusSubscription?: Subscription;
  private regionId = 'account-actions';

  constructor(
    private mycontentService: MycontentserviceService,
    private downloadProgressService: DownloadProgressService,
    private authService: AuthenticateserviceService,
    private walletService: WalletinfoService,
    private sanitizer: DomSanitizer,
    private myContentService: MycontentserviceService,
    private router: Router,
    private whitelabelService: WhiteLabelService,
    private bridgeService: IosBridgeService,
    private device: DeviceService,
    private adResolver: AdResolverService,
    private tvNav: TVNavigationService,
    private toastrService: CustomControlsService,
    private breakpointObserver: BreakpointObserver,
    private http: HttpClient
  ) { }

  /** Ad creative for this placement. Was three inline `device.isMobile() ? … : …`
      ternaries with the keys hardcoded, so a key rotation in ad-config.ts left
      this page on the old creative. Keeps the same breakpoint as before, but as
      a getter it re-reads on resize instead of latching the first value. */
  get adSlot(): any {
    return this.device.isMobile() ? AD_CONFIG.mobile.banner : AD_CONFIG.desktop.leaderboard;
  }

  ngOnInit(): void {
    this.isTV = this.device.isTV();
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isMobile = result.matches;
    });
    this.userId = localStorage.getItem('userId');
    this.screenname = localStorage.getItem('screenName');
    this.mail = localStorage.getItem('userName');
    this.contact = localStorage.getItem('contact');
    this.profileImage = localStorage.getItem('profileImage') || '';

    if(this.userId){
      this.getUserWallet(this.userId);
    }
    this.getWatchlist();
    this.getHistory();
    this.prepareDownloadData();
  }

  ngAfterViewInit(): void {
    if (this.isTV) {
      // Wait for action items to render
      setTimeout(() => {
        this.registerAccountNavigation();
      }, 100);

      // Re-register when items change
      this.accountItems.changes.subscribe(() => {
        this.registerAccountNavigation();
      });
    }
  }

  ngOnDestroy(): void {
    if (this.isTV) {
      this.tvNav.unregisterRegion(this.regionId);
      this.focusSubscription?.unsubscribe();
    }
    this.stopQrScanner();
  }

  private registerAccountNavigation(): void {
    if (!this.accountItems || this.accountItems.length === 0) return;

    const region: Region = {
      id: this.regionId,
      type: 'row',
      elementRef: this.actionsContainer || this.accountItems.first,
      focusableItems: this.accountItems.toArray()
    };

    this.tvNav.registerRegion(region);

    // Subscribe to focus changes
    this.focusSubscription?.unsubscribe();
    this.focusSubscription = this.tvNav.focus$.subscribe(focusKey => {
      if (focusKey && focusKey.startsWith(this.regionId + ':')) {
        this.focusedItemIndex = parseInt(focusKey.split(':')[1], 10);
      } else if (this.focusedItemIndex !== -1) {
        this.focusedItemIndex = -1;
      }
    });
  }

  async logout(){
    try{
      this.isLoading = true;
      if (this.bridgeService.isIOS()) {
        this.bridgeService.send('logout', {"userId" : this.userId})
      }
      this.authService.logout();
      this.isLoading = false;
    }catch(error){
      console.error('Error during logout:', error);
      this.isLoading = false;
    }
  }

  getUserWallet(userId:string){
    this.walletService.getWalletInfo(`wallet-id-${userId}`).subscribe((result)=>{
      console.log(result)
      this.wallet = result;
    })
  }

  getWatchlist() {
    this.isWatchlistLoading = true;
    this.userId = localStorage.getItem('userId');
    this.mycontentService.getWatchListOfUser(this.userId).subscribe(result2 => {
      result2.forEach(movie => {
        this.myContentService.transformData(movie);
        if (movie.content_sub_type === '1') {
          this.queue.push(movie);
        } else if (movie.content_sub_type === '2') {
          this.watchlistList.push(movie);
        } else{
          this.watchlistList.push(movie);
        }
      });

      this.mapwatchContent(result2);
      this.mapChannelSubscription(result2);
      this.isWatchlistLoading = false;
    }, () => {
      this.isWatchlistLoading = false;
    });
  }
  

  getHistory(){
    this.isHistoryLoading = true;
    this.mycontentService.getContinueWatching().subscribe((movies)=>{
      this.historyList = movies;
      this.isHistoryLoading = false;
    }, () => {
      this.isHistoryLoading = false;
    })
  }

  mapwatchContent(list:any[]) {
    var usrId = localStorage.getItem("userId");
    this.myContentService.getWatchListOfUser(usrId).subscribe(watchresult => { 
      list.forEach(section => {
        section.isInWatchList = false;
          watchresult.forEach(wlitem => {
            if (section.vidLibId == wlitem.vidLibId) {
              section.isInWatchList = true;
            }
          })
      })
    });
    this.isLoading=false
  }

  mapChannelSubscription(list:any) {
    this.walletService.getUserSubscriptions().subscribe(result =>{
      list.forEach(section => {
          result?.forEach(sitem => {
            if(section.channelId == sitem.channelId && sitem.isActive){
              section.isChannelSubscribed = true;
              section.expiringDate = sitem.dateOfExpiry;
            }
            if((section.vidLibId == sitem.contentId || section.vidLibId == sitem.vidLibId) && sitem.isActive){
              section.isPPVSubscribed = true;
              section.expiringDate = sitem.dateOfExpiry;
            }else if(section.channelId == sitem.channelId && sitem.isActive && section.sub_value === '0'){
              section.isPPVSubscribed = true;
              section.expiringDate = sitem.dateOfExpiry;
            }
          })
      })
    })
  }

  async prepareDownloadData() {
    try {
      const content = await this.getStorageContentWithRetry();

      if (!content || content.length === 0) {
        console.warn('No content found in storage.');
        return;
      }

      for (let videoEle of content) {
        if (videoEle.appMetadata?.thumbnail instanceof Blob) {
          videoEle.appMetadata.downloadBlob = URL.createObjectURL(videoEle.appMetadata.thumbnail);
        } else {
          console.warn('Invalid or missing thumbnail for:', videoEle);
          videoEle.appMetadata.downloadBlob = './assets/img/thumbnail.png';
        }
        if (!videoEle.thumbnailUrl) {
          videoEle.thumbnailUrl = videoEle.appMetadata.downloadBlob;
        }
        if (videoEle.appMetadata) {
          videoEle.preparedVideoType = this.prepareVideoType(videoEle.appMetadata);
          videoEle.vidLibId = videoEle.appMetadata.vidLibId;
          videoEle = { ...videoEle, ...videoEle.appMetadata };
        } else {
          console.warn('appMetadata is missing for video:', videoEle);
        }
        if(!videoEle.thumbnail.includes(this.downloadProgressService.currentDownloadVideoId)){
          this.downloadList.push(videoEle);
        }
      }
  
    } catch (error) {
      console.error('Error in prepareDownloadData:', error);
    }
  }
  
  async getStorageContentWithRetry(retries = 3, delay = 500): Promise<any[]> {
    let content;
    for (let attempt = 0; attempt < retries; attempt++) {
      try {
        content = await window.storage?.list();
        if (content && content.length > 0) {
          return content;
        }
      } catch (error) {
        console.error('Error fetching from storage on attempt', attempt + 1, error);
      }
      await this.delay(delay);
    }
    return [];
  }
  
  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  sanitizeBlobUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  openEdit(){
    const route = this.whitelabelService.getPrefixedRoute('registration')
    console.log(route)
    this.router.navigate([route], { queryParams: { updateProfile: true } });
  }

  sortDownloadedList() {
    this.downloadList = this.downloadList.sort( (a, b) =>{
      return new Date(b.downloaded).getTime() - new Date(a.downloaded).getTime();
    })
  }

  removeDuplicates(data) {
    const tempObj = {};
    const finalResult = [];
    for(const ele of data) {
      if(!tempObj[ele.vidLibId]){
        finalResult.push(ele);
        tempObj[ele.vidLibId] = ele.vidLibId;
      }
    }
    return finalResult;
  }

  prepareVideoType(category) {
    if(category.isFreeVideo) {
      return 'FREE';
    } else if((category.sub_value && category.sub_value != '0')){
      return category.sub_value;
    } else if((category.unSub_value && category.unSub_value != '0')){
      return category.unSub_value;
    } else {
      return 'Sub';
    }
  }

  getLink(path: string): string {
    return this.whitelabelService.getPrefixedRoute(path);
  }

  handleMovieAction(event: { movie: any, action: string }) {
    if (event.action === 'remove') {
      this.mycontentService.deleteWatchHistoryEntry(event.movie.vidLibId).subscribe(() => {
        this.historyList = this.historyList.filter(m => m.vidLibId !== event.movie.vidLibId);
        this.showSuccess(`Removed from history`);
      });
    }
  }

  // QR Scanner methods
  openQrScanner() {
    this.scanError = '';
    this.isScannerOpen = true;
    this.isScannerActive = true;
    requestAnimationFrame(() => {
      setTimeout(() => this.startQrScanner(), 300);
    });
  }

  closeQrScanner() {
    this.isScannerOpen = false;
    this.isScannerActive = false;
    this.isScanProcessing = false;
    this.stopQrScanner();
  }

  private startQrScanner() {
    if (this.html5QrCode) return;
    this.html5QrCode = new Html5Qrcode('qr-reader-account');
    this.html5QrCode.start(
      { facingMode: 'environment' },
      { fps: 10, qrbox: 250 },
      (decodedText) => {
        try {
          const data = JSON.parse(decodedText);
          const requestId = data.request_id;
          this.isScanProcessing = true;
          this.stopQrScanner();
          this.scanQrRequest(requestId);
        } catch {
          this.scanError = 'Invalid QR code';
        }
      },
      () => {}
    ).catch(err => {
      console.error('QR start failed', err);
      this.scanError = 'Camera permission denied';
      this.isScannerActive = false;
    });
  }

  private stopQrScanner() {
    if (this.html5QrCode) {
      this.html5QrCode.stop().then(() => {
        this.html5QrCode.clear();
        this.html5QrCode = undefined as any;
      });
    }
  }

  private scanQrRequest(requestId: string) {
    const formData = new FormData();
    formData.append('request_id', requestId);
    this.http.post(`${environment.TQR_SERVICE}masterSlaveController/approvePairRequest`, formData).subscribe({
      next: (result: any) => {
        this.isScanProcessing = false;
        if (result.status === 'SUCCESS') {
          this.showSuccess('Device login approved');
          this.closeQrScanner();
        } else {
          this.toastrService.showNotification('warning', '', 'Approval failed', 5000);
        }
      },
      error: () => {
        this.isScanProcessing = false;
        this.scanError = 'Failed to process QR request';
      }
    });
  }

  showSuccess(message:any) {
    this.toastrService.showNotification(
      'success',
      '',
      message,
      3000
    );
  }
}